<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  import { updateDocumentTitle } from '@/utils/document-title-util';

  export default {
    name: 'App',
    created() {

      // 恢复主题
      this.$store.dispatch('theme/recoverTheme');
    },
    methods: {
      /* 路由切换更新浏览器标题 */
      setDocumentTitle() {
        updateDocumentTitle(
          this.$route,
          (key) => this.$t(key),
          this.$store.state.theme.tabs
        );
      }
    },
    watch: {
      '$i18n.locale'() {
        this.setDocumentTitle();
      },
      $route() {
        this.setDocumentTitle();
      }
    }
  };
</script>
<style lang="scss">

.image-items{
  display: flex;
  align-items: stretch;
  .ele-image-upload-list .ele-image-upload-item{
    width: 36px;
    height: 36px;
  }
}
.index_bg{
  width: 100%;
  background: rgba(0,0,0,.6)!important;
  z-index: 0!important;
}
.ele-file-list .ele-file-list-item .ele-file-list-item-icon>.ele-file-list-item-icon-image{
  object-fit: contain!important;
}
.detail-carousel-images > img{
  object-fit: contain;
}

.phone-model .content img{
  max-width: 100%!important;
  height: auto!important;
}
</style>

